export const mapsConstants = {
  GET_ARTISTS_STREAMS_MAPS_REQUEST: 'GET_ARTISTS_STREAMS_MAPS_REQUEST',
  GET_ARTISTS_STREAMS_MAPS_SUCCESS: 'GET_ARTISTS_STREAMS_MAPS_SUCCESS',
  GET_ARTISTS_STREAMS_MAPS_FAILURE: 'GET_ARTISTS_STREAMS_MAPS_FAILURE',
  GET_ARTISTS_STREAMS_BY_REGION_MAPS_REQUEST: 'GET_ARTISTS_STREAMS_BY_REGION_MAPS_REQUEST',
  GET_ARTISTS_STREAMS_BY_REGION_MAPS_SUCCESS: 'GET_ARTISTS_STREAMS_BY_REGION_MAPS_SUCCESS',
  GET_ARTISTS_STREAMS_BY_REGION_MAPS_FAILURE: 'GET_ARTISTS_STREAMS_BY_REGION_MAPS_FAILURE'
}
